/*
* Component for a small bookmark which sits in the corner of a job card that allows the user to save the job.
*/
<template>
	<div :class="classes" @click.prevent="doClick" title="Favourite" aria-label="Favourite">
    <slot />
		<block-spinner :active="isLoading" size="4" :color="spinnerColor" :key="`spinner_${is_saved}`" class="ml-3"></block-spinner>
		<svg-heart v-if="!isLoading" class="btn-bookmark-icon"></svg-heart>
  </div>
</template>

<script>
	import AuthMixins from '@/mixins/AuthMixins';

	export default {
		name: 'ActionBookmarkJob',

		mixins: [AuthMixins],

		props: {
			job_id: {
				type: String
			}
		},

		data() {
			return {
				saved_jobs: false,
				isLoading: false,
        bookmarkText: ''
			}
		},

		mounted() {

		},

		methods: {
			doClick() {
				if (this.me) {
					this.toggleBookmark();
				} else {
					this.emitter.emit("openModal", { name: 'SignIn', persistent: false });
				}
			},
			toggleBookmark() {
				this.isLoading = true;

				let payload = {
					'job_id': this.job_id
				}

				if (this.is_saved) {
          this.bookmarkText = 'Listing removed successfully';
					this.emitter.emit('gaEventTrack', {'category':'job', 'action':'unsave', 'label':this.job_id});
				} else {
          this.bookmarkText = 'Listing saved - You can view this on your <a href="/" class="underline">logged in home page</a>';
					this.emitter.emit('gaEventTrack',  {'category':'job', 'action':'save', 'label':this.job_id});
				}

				return this.$api.bookmarkJob(payload).then(
					(response) => {
						if (response.data.status == 'success') {
	        		this.updateUser(response.data.enc_user);
							this.isLoading = false;
              this.emitter.emit('toast', {message:this.bookmarkText, type:'success'});
	        	}
					}
				).catch((response) => {
					console.log("Could not toggle bookmark job.");
				});
			}
		},

		computed: {
			is_saved() {
				if(this.saved_jobs) {
					let found = this.saved_jobs.find((job) => {
						return job['job-id'] == this.job_id;
					});
					return (found);
				}
			},
			classes() {
				return {
					'btn-bookmark': true,
					'active': this.is_saved,
				}
			},
			spinnerColor() {
				return this.is_saved ? 'text-pink' : 'text-pink';
			}
		},
		watch: {
    	me() {
    		this.saved_jobs = (this.$store.getters.getUser['saved-jobs'] !== undefined) ? this.$store.getters.getUser['saved-jobs'] : false;
    	}
    }
	};
</script>
